commonModule.factory('stacktraceBuilderService', ['$q',
    function ($q) {
    var stacktraceBuilderService = {};

    stacktraceBuilderService.getSourceMappedStackTrace = function(error){
        return StackTrace.fromError(error)
    }

    return stacktraceBuilderService;
}]);